import React from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'
import { ImageStyle } from 'react-native-fast-image'
import { Text } from '@components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { ContentLoader, Circle } from '@src/components/ContentLoader'
import { ImageWithPlaceholder } from '../Image/FastImageWithPlaceholder'

interface CoachAvatarProps {
  photo?: string | null
  showPrimary?: boolean
  style?: StyleProp<ViewStyle>
}

export const CoachAvatar = ({ photo, showPrimary = false, style }: CoachAvatarProps) => {
  const styles = useStyleSheet(themedStyle)

  if (!photo) {
    return null
  }

  return (
    <View>
      <ImageWithPlaceholder
        style={[styles.coachPhoto as ImageStyle, style as ImageStyle | undefined]}
        source={{ uri: photo }}
        placeholderComponent={
          <ContentLoader>
            <Circle cx="50%" cy="50%" r="50%" />
          </ContentLoader>
        }
      />
      {showPrimary && (
        <View style={styles.primaryBadge}>
          <Text type="micro" bold style={styles.primaryBadgeText}>
            PRIMARY
          </Text>
        </View>
      )}
    </View>
  )
}

const themedStyle = StyleService.create({
  coachPhoto: {
    width: 48,
    height: 48,
    borderRadius: 32,
  },
  primaryBadge: {
    position: 'absolute',
    left: -4,
    right: -4,
    bottom: -6,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 16,
    paddingVertical: 4,
    backgroundColor: 'theme.success.lightest',
  },
  primaryBadgeText: {
    textAlign: 'center',
    color: 'theme.success.base',
  },
  unreadMessageDot: {
    position: 'absolute',
    top: 0,
    right: 4,
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: 'theme.error.base',
  },
})
